import { FilterGroup } from 'types';
import { notEmpty } from '@/utilities/helpers';
import { IGetFilterGroupsProps } from '../types';
import { getDependantsFilter } from './dependants';
import { getImmigrationProvidersFilter } from './immigrationProviders/immigrationProviders';
import { getProgrammableTagsFilter } from './programableTags/programmableTags';
import { getServicesFilter } from './services/services';
import { getTagsFilter } from './tags/tags';
import { getVisaStatusFilter } from './visaStatus/visaStatus';
import { getShareCodeFilter } from './shareCode/shareCode';

export const getOtherGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'OTHER',
    filters: [
      getTagsFilter(props),
      getProgrammableTagsFilter(props),
      getVisaStatusFilter(props),
      getShareCodeFilter(props),
      getDependantsFilter(props),
      getServicesFilter(props),
      getImmigrationProvidersFilter(props),
    ].filter(notEmpty),
  };
};
